import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { WarehouseInfoType } from '@kinderlabs-pos/shared-data-type';

export const updateWarehouseInfoAsync =
	(rootUrl: string) =>
	async (updateInfo: Omit<WarehouseInfoType, 'storeId'> & { storeId: number | null }) =>
		(await posAxiosClient.put<WarehouseInfoType>(`${rootUrl}/warehouse`, { ...updateInfo })).data;
